import React from "react";
import { Box, Link } from "@mui/material";

/**
 * Toggle between classic and progressive login experiences.
 * @param {{ experience: 'classic' | 'progressive', onChange: (next: 'classic' | 'progressive') => void }} props
 */
export default function LoginExperienceSwitcher({ experience, onChange }) {
  const isClassic = experience === "classic";
  const next = isClassic ? "progressive" : "classic";
  const label = isClassic
    ? "Try our new login experience"
    : "Use Classic Login";

  return (
    <Box mt={3} textAlign="center">
      <Link
        component="button"
        type="button"
        color="primary"
        className="forgot-password-btn"
        onClick={() => onChange(next)}
        data-testid="login-experience-switcher"
        aria-label={label}
      >
        {label}
      </Link>
    </Box>
  );
}
